const fragShader = `
    precision mediump float;
    uniform float iTime;
    uniform float textureBrightness;
    uniform vec2 iResolution;
    uniform vec3 iCamPos;
    uniform vec3 brightnessColor;
    uniform sampler2D uMainSampler;
    varying vec2 outTexCoord;

    float sdBox(vec3 p, vec3 b) {
        vec3 q = abs(p) - b;
        return length(max(q, 0.0)) + min(max(q.x, max(q.y, q.z)), 0.0);
    }

    vec3 opRep(in vec3 p, in vec3 c, in vec3 l) {
      vec3 q = mod(p - 0.5 * c, c) - 0.5 * c;
      return p - q + l * clamp(q, -0.5 * c, 0.5 * c);
      }  

    float map(vec3 p) {
        p.z += 5.0;
        p = opRep(p, vec3(4.0), vec3(1.0));
        return sdBox(p, vec3(1.0));
    }


    vec3 calcNormal(in vec3 p) {
        const float h = 1e-5;
        const vec2 k = vec2(1, -1);
        return normalize(k.xyy * map(p + k.xyy * h) +
                          k.yyx * map(p + k.yyx * h) +
                          k.yxy * map(p + k.yxy * h) +
                          k.xxx * map(p + k.xxx * h));
    }

    void main() {
      vec4 startColor = texture2D(uMainSampler, outTexCoord);
      vec2 uv = outTexCoord / iResolution.xy;

      vec3 rayOri = vec3((uv - 0.5) * vec2(iResolution.x / iResolution.y, 1.0) * 6.0, 3.0);
      vec3 rayDir = vec3(0.0, 0.0, -1.0);
      float maxDepth = 6.0;

      float depth = 0.0;
      vec3 p;

      for (int i = 0; i < 64; i++) {
      p = rayOri + rayDir * depth;
      float dist = map(p);
      depth += dist;
      if (dist < 1e-6) {
            break;
      }
      }

      depth = min(maxDepth, depth);
      vec3 n = calcNormal(p);
    //     float b = max(0.0, dot(n, vec3(0.577)));
    //     vec3 col = (0.5 + 0.5 * cos((b + iTime * 3.0) + uv.xyx * 2.0 + vec3(0, 2, 4))) * (0.85 + b * 0.35);
    //   col *= exp(-depth / maxDepth);

    float b = max(0.0, dot(n, vec3(0.0, 1.0, 0.0)));
    vec3 col = (0.5 + 0.5 * cos((b + iTime * 3.0) + uv.xyx * 2.0 + vec3(0, 2, 4))) * (0.85 + b * 0.35);
     col = vec3(0.05 * col.r, 0.4 * col.g, 0.1 * col.b) / 6.1 + brightnessColor / 1.8;
    
      gl_FragColor = vec4(col * textureBrightness, startColor.a) * startColor;
    }
`;

export class GlowPipeline3 extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
      constructor(
            game,
            textureBrightness = 4.5,
            brightnessColor = { x: 0.8, y: 0.4, z: 0.1}
      ) {
            super({
                  game,
                  fragShader,
                  uniforms: [
                        'iTime',
                        'iResolution',
                        'iCamPos',
                        'uMainSampler'
                  ]
            });

            this.textureBrightness = textureBrightness;
            this.color = brightnessColor;
      }
      
      onPreRender() {
            this.set1f('iTime', this.game.loop.time / 2000);
            this.set1f('textureBrightness', this.textureBrightness);
            this.set2f('iResolution', this.renderer.width, this.renderer.height);
            this.set3f('brightnessColor',this.color.x, this.color.y, this.color.z);
            this.set3f('iCamPos', 0, 0, 0); // You may need to set the actual camera position
            this.set1i('uMainSampler', 0);  // Use texture unit 0 for uMainSampler
      }
}
